export default __webpack_public_path__ + "static/media/buttonLoading.a8186a08.svg";